import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import moment from "moment/moment";

const _FM_ReservationResnwebListComponent = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
    if (props.errors && props.errors[0]) {
      props.errors.map(error => {
        window.App.customToastShow('warn', error, '', 10000)
      })
    }
  }, [window.App.state.rerenderReservationResnwebList])

  return (
    <Panel className={"reservation-resnweb-list p-mt-3"}>
      <h3 className={"p-mt-0"}>
        RESnWEB
      </h3>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="captured_at">RESnWEB reference ID</label>
            <span className="p-d-block p-text-bold">
             {props?.reservation?.resnweb_reference_id}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="captured_at">RESnWEB room reference ID</label>
            <span className="p-d-block p-text-bold">
             {props?.reservation?.resnweb_room_reference_id}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="captured_at">RESnWEB guest reference ID</label>
            <span className="p-d-block p-text-bold">
             {props?.reservation?.resnweb_guest_reference_id}
            </span>
          </div>
        </div>
      </div>
    </Panel>
  )
}
export default withTranslation('common')(_FM_ReservationResnwebListComponent);
